import { cn } from '@/lib/utils.js';

type PageLayoutProps = {
  title?: string;
  description?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  wide?: boolean;
};

export function PageLayout({
  title,
  description,
  actions,
  children,
  className,
  wide,
}: PageLayoutProps) {
  return (
    <div className={cn('mx-auto', wide ? 'max-w-7xl' : 'max-w-5xl', className)}>
      {(title || actions) && (
        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div className="min-w-0">
            {title ? (
              <h1
                className="text-2xl font-semibold tracking-tight"
                style={{ fontFamily: 'var(--font-heading)', color: 'var(--text)' }}
              >
                {title}
              </h1>
            ) : null}
            {description ? (
              <p className="mt-1 text-sm" style={{ color: 'var(--text2)' }}>
                {description}
              </p>
            ) : null}
          </div>
          {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
        </div>
      )}
      {children}
    </div>
  );
}
